import React from "react";
import { Text, TextInput } from "@jsq/ds/core";
import { sectionContainer, sectionHeader, configFields } from "../styles_vanilla.css";
import { ConfigurationSectionProps } from "../types";
import { BankMappingSelect } from "./BankMappingSelect";
import { FIELD_CONTAINER_STYLE, FIELD_ROW_STYLE } from "./constants";
import { ProviderRow } from "./ProviderRow";
import { VerificationStatusSelect } from "./VerificationStatusSelect";

export const ConfigurationSection: React.FC<ConfigurationSectionProps> = ({
  fidesEnabled,
  onFidesEnabledChange,
  fidesBankMapping,
  onFidesBankMappingChange,
  fidesVerificationStatus,
  onFidesVerificationChange,
  fidesBankSources,
  fidesBankMappingError,
  rpaEnabled,
  onRpaEnabledChange,
  rpaBankMapping,
  onRpaBankMappingChange,
  rpaBankSources,
  rpaBankMappingError,
  fundRecsEnabled,
  onFundRecsEnabledChange,
  fundRecsUdf,
  onFundRecsUdfChange,
  fundRecsUdfError,
  fundRecsEnabledError,
}) => {
  return (
    <div className={sectionContainer}>
      <div className={sectionHeader}>CONFIGURATION</div>

      <ProviderRow
        label="Fides"
        enabled={fidesEnabled}
        onToggle={onFidesEnabledChange}
        testId="fides-toggle"
      />
      {fidesEnabled && (
        <div className={configFields}>
          <div style={FIELD_ROW_STYLE}>
            <BankMappingSelect
              label="Bank mapping for Fides"
              value={fidesBankMapping}
              onChange={onFidesBankMappingChange}
              bankSources={fidesBankSources}
              testId="fides-bank-mapping-select"
              width="60%"
              error={fidesBankMappingError}
            />
            <VerificationStatusSelect
              value={fidesVerificationStatus}
              onChange={onFidesVerificationChange}
              testId="fides-verification-select"
              width="40%"
            />
          </div>
        </div>
      )}

      <ProviderRow
        label="RPA"
        enabled={rpaEnabled}
        onToggle={onRpaEnabledChange}
        testId="rpa-toggle"
      />
      {rpaEnabled && (
        <div className={configFields}>
          <BankMappingSelect
            label="Bank mapping for RPA"
            value={rpaBankMapping}
            onChange={onRpaBankMappingChange}
            bankSources={rpaBankSources}
            testId="rpa-bank-mapping-select"
            width="60%"
            error={rpaBankMappingError}
          />
        </div>
      )}

      <ProviderRow
        label="FundRecs export"
        enabled={fundRecsEnabled}
        onToggle={onFundRecsEnabledChange}
        testId="fundrecs-toggle"
        showHelpIcon
        helpTooltipContent="To enable FundRecs export, Fides or RPA must be enabled first"
        disabled={!fidesEnabled && !rpaEnabled}
      />
      {fundRecsEnabled && (
        <div className={configFields} style={{ borderBottom: "none" }}>
          <div style={{ ...FIELD_CONTAINER_STYLE, width: "100%" }}>
            <Text variant="strong-sm">UDF</Text>
            <TextInput
              value={fundRecsUdf}
              onSetValue={onFundRecsUdfChange}
              placeholder="Enter UDF value"
              data-testid="fundrecs-udf-input"
              errorMessage={fundRecsEnabledError || fundRecsUdfError}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigurationSection;
